import { z } from 'zod';

import { OrderLabelInput } from '@nucleus-commerce/api-client/admin';

/** URL search params of the production board; mirrors GET /stores/{storeId}/production. */
export const productionBoardSearchSchema = z.object({
  stage: z.string().max(60).optional(),
  label: z.enum(OrderLabelInput).optional(),
  q: z.string().max(120).optional(),
});

export type ProductionBoardSearch = z.infer<typeof productionBoardSearchSchema>;
